import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { GoArrowDown } from "react-icons/go";

import aiLogo from "../../../assets/img/Products/AeroGenix/automation.png"; // AeroGenix AI logo
import gptHexagon from "../../../assets/img/Products/AeroGenix/hexagon.png"; // AeroGenix GPT logo

export default function AeroGenixSolutionsSection() {
  return (
    <section className="mx-4 sm:mx-6 md:mx-8 bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl shadow-2xl overflow-hidden py-12 sm:py-16">
      {/* Header */}
      <div className="px-6 sm:px-8 text-center border-b border-gray-200 pb-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">Solution</h2>
        <p className="mt-3 sm:mt-2 text-gray-600 max-w-xl mx-auto text-lg">
          Select the AeroGenix product that best fits your enterprise needs
        </p>

        {/* Bouncy arrow with tooltip */}
        <div className="relative flex justify-center mt-5 group cursor-pointer">
          <GoArrowDown className="w-6 h-6 text-gray-600 animate-bounce" />
          <span className="absolute bottom-8 bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded border border-indigo-200 shadow opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Scroll Below
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 sm:px-8 pt-6 flex flex-col sm:flex-row justify-center sm:space-x-6 lg:space-x-10 xl:space-x-24 space-y-6 sm:space-y-0">
        {/* AeroGenix AI */}
        <div className="group relative bg-white border border-gray-200 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col p-5 sm:p-6 md:p-7 h-[380px] sm:h-[400px] md:h-[420px] lg:h-[440px] w-full max-w-[360px] sm:max-w-[400px] md:max-w-[420px]">
          {/* Hover gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl" />

          <div className="relative flex flex-col flex-1">
            {/* AI Logo */}
            <div className="flex items-center mb-3">
              <img src={aiLogo} alt="AeroGenix AI" className="w-10 h-10 mr-3" />
              <h3 className="text-xl md:text-2xl font-semibold text-gray-800">AeroGenix AI</h3>
            </div>

            <p className="text-gray-600 text-base md:text-lg flex-1 mt-2">
              AeroGenix AI is a cutting-edge platform that enables enterprises to seamlessly develop, deploy, and scale Generative AI (GenAI) and Agentic AI solutions.
            </p>

            <div className="mt-4">
              <Link
                to="/aerogenix-ai"
                className="w-full flex items-center justify-center gap-1 md:gap-2 text-white bg-indigo-600 hover:bg-indigo-700 px-3 md:px-5 py-2 md:py-2.5 rounded-lg transition-all duration-300 group/btn text-sm md:text-base"
              >
                <span className="font-medium">Explore AeroGenix AI</span>
                <HiArrowRight className="transition-transform duration-300 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
              </Link>
            </div>
          </div>
        </div>

        {/* AeroGenix GPT */}
        <div className="group relative bg-white border border-gray-200 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col p-5 sm:p-6 md:p-7 h-[380px] sm:h-[400px] md:h-[420px] lg:h-[440px] w-full max-w-[360px] sm:max-w-[400px] md:max-w-[420px]">
          {/* Hover gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl" />

          <div className="relative flex flex-col flex-1">
            {/* GPT Logo */}
            <div className="flex items-center mb-3">
              <img src={gptHexagon} alt="AeroGenix GPT" className="w-10 h-10 mr-3" />
              <h3 className="text-xl md:text-2xl font-semibold text-gray-800">AeroGenix GPT</h3>
            </div>

            <p className="text-gray-600 text-base md:text-lg flex-1 mt-2">
              AeroGenix GPT is tailored for businesses aiming to optimize operations, automate workflows, and derive AI-driven insights.
            </p>

            <div className="mt-4">
              <Link
                to="/aerogenix-gpt"
                className="w-full flex items-center justify-center gap-1 md:gap-2 text-white bg-cyan-600 hover:bg-cyan-700 px-3 md:px-5 py-2 md:py-2.5 rounded-lg transition-all duration-300 group/btn text-sm md:text-base"
              >
                <span className="font-medium">Explore AeroGenix GPT</span>
                <HiArrowRight className="transition-transform duration-300 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
